import React from 'react';
import ReactDOM from 'react-dom/client';

/* Order matters: tokens define the variables, base consumes them, then
   components. Bootstrap and Font Awesome are gone — the previous site loaded
   both plus three Google font families for a handful of grid classes and
   icons that react-icons already provides. */
import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
